class MultiquoteDebugLog {
    constructor(request, response) {
        this.request = request
        this.response = response
    }

    static fromJson({ request = null, response = null } = {}) {
        return new MultiquoteDebugLog(request, response)
    }
}

export default MultiquoteDebugLog
